
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { IUser } from '@/api/types'
// 导入子组件
import UserInfoCard from './components/UserInfoCard.vue'
import UserStatusComponent from './components/UserStatusComponent.vue'
import UserRolesCard from './components/UserRolesCard.vue'
import UserDeptsCard from './components/UserDeptsCard.vue'
import UserProjectsCard from './components/UserProjectsCard.vue'
import EditUserInfoDialog from './components/EditUserInfoDialog.vue'
import BindAccountDialog from './components/BindAccountDialog.vue'
import ResetPasswordDialog from './components/ResetPasswordDialog.vue'
// 导入默认头像图片
const DefaultAvatar = require('@/assets/leaky_hunter_icon_small.png')

@Component({
  name: 'Profile',
  components: {
    UserInfoCard,
    UserStatusComponent,
    UserRolesCard,
    UserDeptsCard,
    UserProjectsCard,
    EditUserInfoDialog,
    BindAccountDialog,
    ResetPasswordDialog
  }
})
export default class extends Vue {
  public editDialogVisible = false
  public bindDialogVisible = false
  public resetPasswordDialogVisible = false
  public bindType = ''

  get userInfo(): IUser | null {
    return UserModule.userInfo
  }

  created() {
    // this.fetchUserInfo()
  }

  get avatar(): String {
    return DefaultAvatar
  }

  beforeMount() {
    this.fetchUserInfo()
  }

  public async fetchUserInfo() {
    try {
      await UserModule.UpdateUserInfo()
      await UserModule.UpdateUserRoles()
      await UserModule.UpdateUserDepts()
      await UserModule.UpdateUserProjects()
      // console.log('获取用户信息成功')
      // console.log(this.userInfo)
    } catch (error) {
      console.error('获取用户信息失败:', error)
    }
  }

  public handleBindWechat(type: string) {
    this.bindDialogVisible = true
    this.bindType = type
  }

  public handleBindPhone(type: string) {
    this.bindDialogVisible = true
    this.bindType = type
  }

  public handleEditSuccess() {
    this.editDialogVisible = false
    this.fetchUserInfo()
  }

  public handleBindSuccess() {
    this.bindDialogVisible = false
    this.fetchUserInfo()
  }

  public handleResetPasswordSuccess() {
    this.resetPasswordDialogVisible = false
  }
}
